function e(a, n) {
  return a != null && n in Object(a);
}
var s = e;
export {
  s as default
};
//# sourceMappingURL=_baseHasIn.js.map
